// ── Header sticky + Reveal au scroll ─────────────────────────

function initHeader() {
  const header = document.querySelector('header.wp-block-template-part');
  if (!header) return;

  // Hysteresis : seuils différents pour éviter l'oscillation
  // quand le header réduit sa taille et fait bouger scrollY.
  const ON  = 80; // active is-scrolled après 80px
  const OFF = 5; // désactive seulement sous 20px

  const toggle = () => {
    const y = window.scrollY;
    if ( ! header.classList.contains('is-scrolled') && y > ON  ) header.classList.add('is-scrolled');
    if (   header.classList.contains('is-scrolled') && y < OFF ) header.classList.remove('is-scrolled');
  };

  window.addEventListener('scroll', toggle, { passive: true });
  toggle();
}

function initReveal() {
  const els = document.querySelectorAll('.ndg-reveal, .is-style-ndg-reveal');
  if (!els.length) return;

  const obs = new IntersectionObserver((entries) => {
    entries.forEach((entry, i) => {
      if (!entry.isIntersecting) return;
      setTimeout(() => entry.target.classList.add('is-visible'), i * 80);
      obs.unobserve(entry.target);
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });

  els.forEach(el => obs.observe(el));
}

function revealGroup(selector, { step = 0.09, max = 5, threshold = 0.08, rootMargin = '0px 0px -40px 0px', filter } = {}) {
  const els = [...document.querySelectorAll(selector)].filter(
    el => !el.classList.contains('ndg-reveal') && (!filter || filter(el))
  );
  if (!els.length) return;

  const obs = new IntersectionObserver((entries) => {
    entries.forEach((entry, i) => {
      if (!entry.isIntersecting) return;
      entry.target.style.transitionDelay = (i % max * step) + 's';
      entry.target.classList.add('is-visible');
      obs.unobserve(entry.target);
    });
  }, { threshold, rootMargin });

  els.forEach(el => {
    el.classList.add('ndg-reveal');
    obs.observe(el);
  });
}

document.addEventListener('DOMContentLoaded', () => {
  initHeader();
  initReveal();

  // Passe 1 — blocs "conteneurs" : animent le bloc entier
  // Doit tourner EN PREMIER pour que la passe 2 puisse filtrer leur contenu.
  revealGroup(
    '.wp-block-media-text, .wp-block-columns > .wp-block-column, ' +
    '.wp-block-group.is-style-card, ' +
    '.ndg-card, .ndg-event-row, .ndg-fgrid__item, .ndg-films-slider__slide',
    { step: 0.09, max: 5 }
  );

  // Passe 2 — blocs "feuilles" standalone (headings, textes, images…)
  // Exclus si déjà à l'intérieur d'un bloc animé par la passe 1.
  revealGroup(
    '.wp-block-image, .wp-block-heading, .wp-block-paragraph, .wp-block-list, ' +
    '.wp-block-quote, .wp-block-separator, .wp-block-video, ' +
    '.wp-block-table, .wp-block-embed, .wp-block-buttons',
    {
      filter: el => !el.closest('.ndg-reveal') &&
                    !el.closest('header') &&
                    !el.closest('footer'),
    }
  );
});
